// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1uH5B","subheader":"ReorderModal_subheader__3fT8z","listWrap":"ReorderModal_listWrap__2CkKp"};